<template>
    <div v-if="show" class="support-overlay" @click="closePopup">
        <div class="support-modal" @click.stop>
            <h3 class="header-2">{{ $t('support.title') }}</h3>

            <div class="support-options">
                <div class="email-container">
                    <a href="mailto:support@avacapo.com" class="email-link gradient-text">
                        support@avacapo.com
                    </a>
                    <button class="copy-btn" @click="copyEmail">
                        <BaseIcon :iconName="copied ? 'check' : 'copy'" :color="copied ? '#20AD8B' : 'white'"
                            :width="16" :height="16" />
                    </button>
                </div>
                <p class="email-note">{{ $t('support.responseTime') }}</p>
                <div class="form-actions">
                    <button class="cancel-btn" @click="closePopup">{{ $t('common.close') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import BaseIcon from '@/components/BaseComponents/BaseIcon.vue';

defineProps({
    show: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['close']);
const copied = ref(false);

function closePopup() {
    emit('close');
}

function copyEmail() {
    navigator.clipboard.writeText('support@avacapo.com');
    copied.value = true;
    setTimeout(() => {
        copied.value = false;
    }, 2000);
}
</script>

<style scoped>
.support-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--overlay-medium);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: var(--z-index-popover);
    backdrop-filter: blur(4px);
}

.support-modal {
    background: var(--color-background);
    padding: var(--spacing-2xl);
    border-radius: var(--border-radius-lg);
    width: 90%;
    max-width: 500px;
    box-sizing: border-box;
}

.support-modal h3 {
    margin: 0 0 var(--spacing-lg-xl) 0;
    color: var(--color-white-90);
}

.email-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-sm-md);
    margin: var(--spacing-xl) 0;
}

.email-link {
    text-decoration: none;
    font-size: var(--font-size-lg);
    line-height: var(--font-size-lg);
    transition: opacity var(--transition-normal);
}

.email-link:hover {
    opacity: 0.8;
}

.copy-btn {
    background: none;
    border: none;
    padding: var(--spacing-xs);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--border-radius-xs);
    transition: background var(--transition-normal);
}

.copy-btn:hover {
    background: var(--color-white-10);
}

.email-note {
    color: var(--color-white-60);
    font-size: var(--font-size-md);
    margin-bottom: var(--spacing-xl);
}

.form-actions {
    display: flex;
    justify-content: center;
    margin-top: var(--spacing-xl);
}

.cancel-btn {
    padding: var(--spacing-sm) var(--spacing-2xl);
    border-radius: var(--border-radius-xs);
    border: none;
    cursor: pointer;
    font-size: var(--font-size-sm);
    background: var(--color-white-10);
    color: var(--color-white-70);
    transition: all var(--transition-normal);
}

.cancel-btn:hover {
    background: var(--color-white-20);
}

@media (max-width: 480px) {
    .support-modal {
        padding: var(--spacing-lg-xl);
        width: 95%;
    }

    .cancel-btn {
        width: 100%;
        padding: var(--spacing-md);
    }
}
</style>
